export default __webpack_public_path__ + "static/media/culture_EP13.50c1dbb7.png";